import React from 'react';
import { css } from 'styled-system/css';
import { Divider } from 'styled-system/jsx';

interface Props {
  title: string;
  children: React.ReactNode;
  withTopDivider?: boolean;
}

export default function TechCategory({ title, withTopDivider = true, children }: Props) {
  return (
    <div>
      {withTopDivider && <Divider my='2' color='border.brand' />}
      <h6 className={css({ fontWeight: 'semibold' })}>{title}</h6>
      <div
        className={css({
          display: 'grid',
          gridTemplateColumns: {
            base: 'repeat(10, minmax(0, 1fr))',
            xlDown: 'repeat(8, minmax(0, 1fr))',
            lgDown: 'repeat(9, minmax(0, 1fr))',
            smDown: 'repeat(5, minmax(0, 1fr))',
          },
          gap: '4',
          my: '4',
        })}
      >
        {children}
      </div>
    </div>
  );
}
